function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3217 5.06313H3.77042L6.95248 1.88106C7.38339 1.45016 7.38339 0.754083 6.95248 0.323179C6.52158 -0.107726 5.8255 -0.107726 5.3946 0.323179L0.323179 5.3946C-0.107726 5.8255 -0.107726 6.52158 0.323179 6.95248L5.3946 12.0239C5.8255 12.4548 6.52158 12.4548 6.95248 12.0239C7.38339 11.593 7.38339 10.8969 6.95248 10.466L3.77042 7.2729H18.3217C18.9294 7.2729 19.4266 6.7757 19.4266 6.16801C19.4266 5.56033 18.9294 5.06313 18.3217 5.06313Z",
  fill: "current"
});

function SvgLongArrowleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowleft);
export default __webpack_public_path__ + "static/media/longArrowleft.dcfb9736.svg";
export { ForwardRef as ReactComponent };